var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form',{on:{"submit":_vm.onSubmit}},[_vm._t("default"),_c('b-overlay',{attrs:{"no-wrap":"","show":_vm.loading}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }